import { AppBar, Toolbar, Stack, Button, Typography } from "@mui/material";
import { JSX } from "react";
import { Icons } from "../image/Icons";
import { getPageTitle } from "../util/usePageTitle";
import { Clock } from "./Clock";
import { PageContext } from "../pages/ConsolePages/Pages";
import { useLocation, useNavigate } from "react-router-dom";

export default function PageHeader({ left, center, right }: { left?: JSX.Element; center?: JSX.Element; right?: JSX.Element; }) {
  const growCenter = center != undefined;
  const growLeft = (center || left) != undefined;
  const growRight = (center || right) != undefined;

  return (
    <AppBar position="relative">
      <Toolbar>
        <Stack direction="row" width="100%" height="96px">
          <Stack key="left" width={0} flexGrow={growLeft ? 1 : 0} alignItems="start" justifyContent="center">
            {left}
          </Stack>
          <Stack key="center" width={0} flexGrow={growCenter ? 1 : 0} alignItems="center" justifyContent="center">
            {center}
          </Stack>
          <Stack key="right" width={0} flexGrow={growRight ? 1 : 0} alignItems="end" justifyContent="center">
            {right}
          </Stack>
        </Stack>
      </Toolbar>
    </AppBar>
  );
}

export function SimpleHeader({ pageContext }: { pageContext: PageContext }) {
  const location = useLocation();
  const navigate = useNavigate();

  const back = () => { 
    const idx = (window.history.state?.idx ?? 0) as number;
    if (idx > 0) {
      // 前のページが同一オリジン
      navigate(-1);
    } else {
      // 遷移履歴がなければトップページに
      navigate("/system-admin/");
    }
  };

  const canPageBack = () => {
    let parentPath = location.pathname;
    if (parentPath.length > 1 && parentPath.endsWith("/")) {
      parentPath = parentPath.slice(0, -1);
    }
    return parentPath.lastIndexOf("/") > 0;
  }

  return (
    <PageHeader 
      left={
        <Stack direction="row" justifyItems="center" alignItems="center">
          <Stack display={canPageBack() ? "flex" : "none"}>
            <Button onClick={back}>
              <img width={36} height={36} src={Icons.BigArrowIcon} style={{ marginRight: "16px" }} />
            </Button>
          </Stack>
          <Typography fontSize={30} fontWeight="bold">{getPageTitle(location.pathname)}</Typography>
        </Stack>
      } 
      right={
        <Stack direction="row" justifyItems="center" alignItems="center" gap={4}>
          <Clock />
        </Stack>
      } 
    />
  );
}